import i18n from '../../../../../i18n';

export const noop = () => { };

const tFixed = i18n.getFixedT(null, 'employmentBillboard', 'settings.ruleSet.sortingRuleStep');


/** @type {Object<number, string>} */
export const PRIORITY_LABEL = Object.freeze({
    0: tFixed('included'),
    1: tFixed('excluded'),
});

/**
 * @param {number} order
 * @returns {string}
 */
export const getHyperfindPriorityLabel = (order) => PRIORITY_LABEL[order] || '';